module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/name/prefix.js
// module id = 2020
// module chunks = 2